/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import './style.module.scss';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // padding: grid * 2,
  // margin: `0 ${grid}px 0 0`,

  // change background colour if dragging
  // background: isDragging ? 'lightgreen' : 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'white' : '',
  display: 'flex',
  padding: grid,
  overflow: 'auto',
});

function AnswerType4({ answers, onChange, isAnswer, help }) {
  console.log("🚀 ~ file: AnswerType4.jsx ~ line 40 ~ AnswerType4 ~ answers", answers)
  const [items, setItems] = useState([]);
  const [values, setValues] = useState({});
  console.log("🚀 ~ file: AnswerType4.jsx ~ line 42 ~ AnswerType4 ~ values", values)

  useEffect(() => {
    if (Object.keys(values).some((key) => values[key].length > 0)) {
      if(items.length == 0){
        onChange(values);
      }
    } else {
      onChange('');
    }
  }, [values]);

  const getImg = (title) => {
    const find = answers.find((_i) => _i.title == title);
    return find ? find.url : '';
  };

  useEffect(() => {
    let tmp = [];
    const tmpValues = {};
    answers.forEach((item) => {
      if (item.variants && Array.isArray(item.variants)) {
        tmp = [...tmp, ...item.variants];
        tmpValues[item.title] = [];
      }
    });
    setValues(tmpValues);
    setItems(tmp);
  }, [answers]);

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const data = { ...values, variants: items };

    if (result.source.droppableId != result.destination.droppableId) {
      const tmpSortItems = data[result.destination.droppableId] || [];
      let tmpItems = data[result.source.droppableId] || [];

      if (tmpSortItems.length > 0) {
        tmpSortItems.splice(
          result.destination.index,
          0,
          tmpItems[result.source.index]
        );
      } else {
        tmpSortItems.push(tmpItems[result.source.index]);
      }

      tmpItems = tmpItems.filter((_i, index) => index != result.source.index);

      data[result.destination.droppableId] = tmpSortItems;
      data[result.source.droppableId] = tmpItems;

      setItems(data['variants']);
      delete data['variants'];
      setValues(data);
    }
  };

  const isCorrect = (key, id) => {
    return (answers.find(_i => _i.title == key) || {variants: []}).variants.some(_i => _i._id == id)
  }

  return (
    <div className={'AnswerType4'}>
      {isAnswer && <div className='blockedAnswer' />}
      <DragDropContext onDragEnd={onDragEnd}>
        <div className='block_container'>
          <div className={'title_group'}>Variants</div>
          <Droppable droppableId="variants" direction="vertical">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
                className={'block'}
                {...provided.droppableProps}
              >
                {items.map((item, index) => (
                  <Draggable key={item._id} draggableId={item._id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                        className={'item'}
                      >
                        {item.url && <img src={item.url} />}
                        {!item.url && <div className={'title'}>{item.text}</div>}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
        {/* <div className={'text'}>{'Перетащите ответы'}</div> */}
        {Object.keys(values).map((key) => (
          <div className='block_container'>
            <div className={'title_group'} title={key}>{key}</div>
            <div className={'group'}>
              {getImg(key) && (
                <div className={'item'}>
                  <img src={getImg(key)} />
                </div>
              )}
              <Droppable droppableId={key} direction="vertical">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                    className={'block'}
                  >
                    {values[key].map((item, index) => (
                      <Draggable
                        key={item._id}
                        draggableId={item._id}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                            className={classNames('item', {
                              isCorrect: isAnswer && help && isCorrect(key, item._id), 
                              notCorrect: isAnswer && help && !isCorrect(key, item._id)
                            })}
                          >
                            {item.url && <img src={item.url} />}
                            {!item.url && (
                              <div className={'title'}>{item.text}</div>
                            )}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          </div>
        ))}
      </DragDropContext>
    </div>
  );
}

export default AnswerType4;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswerType4/AnswerType4.jsx